import {ChangeRequestContextualLink} from 'src/openapi/models/ChangeRequestContextualLink';

const SOURCE_NOT_SELECTED = 'Change request should have at least one contextual link';

export const contextualLinksValidation = (
    contextualLinks: ChangeRequestContextualLink[],
): string[] => {
    const errorMassages = [];

    if (contextualLinks.length === 0) {
        errorMassages.push(SOURCE_NOT_SELECTED);
    }

    return errorMassages;
};
